import { MonthsDateRangeType } from '@app/core/date-range/enums/months-date-range-type.enum';
import { _ } from '@ngx-translate/core';

export const monthsDateRangeTypeLocalize = {
  [MonthsDateRangeType.One]: _(`@@months-date-range-type_one`),
  [MonthsDateRangeType.Three]: _(`@@months-date-range-type_three`),
  [MonthsDateRangeType.Six]: _(`@@months-date-range-type_six`),
  [MonthsDateRangeType.Twelve]: _(`@@months-date-range-type_twelve`),
  [MonthsDateRangeType.TwentyFor]: _(`@@months-date-range-type_twenty-for`),
  [MonthsDateRangeType.FullHistory]: _(`@@months-date-range-type_full-history`),
};
